import { Component } from 'react'
import PropTypes from 'prop-types'
import { reduxForm } from 'redux-form'
import { Col, Row } from 'react-bootstrap'

import { SaveButton } from 'components/buttons'
import { Checkbox, Form, Radio, RadioGroup, Select } from 'components/forms'
import { ModalFooter } from 'components/modal'
import Link from 'components/link'
import DateSelect from 'components/date-select'

import { dateString } from 'lib/form-validation'
import { CONFIG } from 'shared/constants'

import { getRegistryId } from 'registry/reducers'
import { saveRegistry } from 'registry/actions'
import AddOne from 'components/add-one'

const SHOWER_GUESTS_TYPES = CONFIG.registry.showerGuestsTypeOptions
const SHOWER_GUEST_COUNTS = CONFIG.registry.showerGuestCountOptions

export const buildValidationErrors = (showers) =>
  showers.map((shower) => {
    const dateVal = dateString(shower.date)
    return dateVal ? { date: dateVal } : null
  })

class ShowerInfoFormView extends Component {
  static propTypes = {
    error: PropTypes.object,
    fields: PropTypes.shape({
      registry: PropTypes.shape({
        showerInfo: PropTypes.shape({
          havingShower: PropTypes.object,
          showers: PropTypes.array,
        }),
      }),
    }),
    handleSubmit: PropTypes.func,
    submitting: PropTypes.bool,
  }

  render() {
    const {
      fields: {
        registry: {
          showerInfo: { havingShower, showers },
        },
      },
      error,
      handleSubmit,
      submitting,
    } = this.props

    return (
      <Form
        className="welcome--shower-info-form"
        error={error}
        onSubmit={handleSubmit(this.handleSubmit)}
      >
        <RadioGroup horizontal title="Do you have an upcoming shower?">
          <Radio
            {...havingShower}
            checked={havingShower.value == true}
            label="Yes"
            onChange={(value) => this.handleHavingShowerChange(true)}
            value={true}
          />
          <Radio
            {...havingShower}
            checked={havingShower.value == false}
            label="No"
            onChange={(value) => this.handleHavingShowerChange(false)}
            value={false}
          />
        </RadioGroup>
        {havingShower.value ? (
          <div>
            {showers.map((shower, index) => (
              <div key={index}>
                <Row>
                  <Col sm={12}>
                    <DateSelect {...shower.date} label="Shower Date" />
                    <Checkbox
                      label="I don't know the date yet"
                      {...shower.dateTbd}
                      checked={shower.dateTbd.checked || !shower.date.value}
                      onChange={(e) => this.handleClearShowerDate(e, index)}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm={4}>
                    <Select {...shower.guestsType} label="Who's Invited?">
                      {SHOWER_GUESTS_TYPES.map((option) => (
                        <option value={option} key={option}>
                          {option}
                        </option>
                      ))}
                    </Select>
                  </Col>
                  <Col sm={4}>
                    <Select
                      {...shower.guestCount}
                      label="Approx. number of guests?"
                    >
                      {SHOWER_GUEST_COUNTS.map((option) => (
                        <option value={option} key={option}>
                          {option}
                        </option>
                      ))}
                    </Select>
                  </Col>
                  <Col sm={4} className="mtxl">
                    {index > 0 ? (
                      <Link
                        className="h7 text-uppercase pull-right"
                        onClick={() => showers.removeField(index)}
                      >
                        remove
                      </Link>
                    ) : null}
                  </Col>
                </Row>

                {index < showers.length - 1 ? <hr className="mbl" /> : null}
              </div>
            ))}
            <div className="mbl">
              <AddOne
                onClick={() =>
                  showers.addField({
                    guestsType: SHOWER_GUESTS_TYPES[0],
                    guestCount: SHOWER_GUEST_COUNTS[0],
                  })
                }
                message="Add Another Shower"
              />
            </div>
          </div>
        ) : null}
        <ModalFooter>
          <SaveButton submitting={submitting} block />
        </ModalFooter>
      </Form>
    )
  }

  handleHavingShowerChange(value) {
    const {
      fields: {
        registry: {
          showerInfo: { havingShower, showers },
        },
      },
    } = this.props

    if (value && showers.length == 0) {
      showers.addField({
        guestsType: SHOWER_GUESTS_TYPES[0],
        guestCount: SHOWER_GUEST_COUNTS[0],
      })
    } else if (!value && showers.length > 0) {
      for (let i = showers.length - 1; i >= 0; i--) {
        showers.removeField(i)
      }
    }

    havingShower.onChange(value)
  }

  handleSubmit(values, dispatch) {
    const {
      registry: {
        showerInfo: { havingShower, showers },
      },
    } = values

    if (havingShower && showers.length > 0) {
      const showerErrors = buildValidationErrors(showers)
      if (showerErrors.find((shower) => shower)) {
        return Promise.reject({
          registry: { showerInfo: { showers: showerErrors } },
        })
      }
    }
    return dispatch(saveRegistry(values))
  }

  handleClearShowerDate(e, index) {
    let checkboxValue = e.target.checked
    const showers = this.props.fields.registry.showerInfo.showers

    showers[index].dateTbd.onChange(checkboxValue)

    if (checkboxValue) {
      showers[index].date.onChange(null)
    }
  }
}

const ShowerInfoForm = reduxForm(
  {
    form: 'showerInfo',
    fields: [
      'registry.id',
      'registry.showerInfo.havingShower',
      'registry.showerInfo.showers[].id',
      'registry.showerInfo.showers[].date',
      'registry.showerInfo.showers[].dateTbd',
      'registry.showerInfo.showers[].guestCount',
      'registry.showerInfo.showers[].guestsType',
    ],
  },
  (state, ownProps) => {
    return {
      initialValues: {
        registry: {
          id: getRegistryId(state),
          showerInfo: {
            havingShower: state.registry.showerInfo.havingShower,
            showers: state.registry.showerInfo.showers,
          },
        },
      },
    }
  }
)(ShowerInfoFormView)

export default ShowerInfoForm
